<app-loading-screen-min [status]="this.statusLoader" [session]=2 [width]="'58%'" [heigth]="'-webkit-fill-available'">
</app-loading-screen-min>
<div class="basicrow msidespad">
  <div class="b-title noline">
    <div class="autocont f-black roboto-m f-bmed pull-left vcenter">
      <div class="tabcell">
        Cuentas
      </div>
    </div>
  </div>
</div>
<div class="basicrow allpads">
  <div class="autorow srchacc  pull-left">
    <label class="label-r">Filtro de Busqueda:
      <a class="linkdefs pull-right c-fltr hidden-xs c-blue" (click)="this.clear()">
        Limpiar filtro <i class="fa fa-trash cursor" aria-hidden="true"></i>
      </a>
    </label>
    <div class="basicrow">
      <div class="sub-text">
        Número de Cuenta:
      </div>
      <input placeholder="Buscar..." class="inp-f" [(ngModel)]="this.inputSearchAccount" maxlength="10"
        (keypress)="this.global.onlyNumberKey($event);">
      <a class="btns red srch-i vcenter" (click)="this.search()">
        <span class="tabcell">
          Buscar&nbsp;&nbsp;<i class="fa fa-search" aria-hidden="true"></i>
        </span>
      </a>
    </div>
  </div>
</div>
<div class="basicrow msidespad f-black f-reg">
  <div class="basicrow topbord">
    Listado de cuentas asociados a su usuario:
  </div>
</div>
<div class="basicrow m-top">
  <div class="basicrow">
    <div class="noData" *ngIf="this.filteredData.length==0">
      Cuentas no asociadas al parametro de búsqueda.
    </div>
    <div>
      <div data-toggle="collapse" [attr.data-target]="'#tab_0'" class="digs-box vcenter" (click)="updateExpand(0)"
        [ngClass]="{'mon': this.expand[0] == true,'': this.expand[0] == false}">
        <div class="tabcell">
          <div class="autorow pull-left">
          </div>
          <div class="autorow pull-right">
            <i class="fa fa-minus" aria-hidden="true"></i>
            <i class="fa fa-plus" aria-hidden="true"></i>
          </div>
        </div>
      </div>
      <div id="tab_0" class="collapse show">
        <div class="basicrow visible-web">
          <div class="tab-tbar">
            <div class="frwds rline vcenter">
              <div class="tabcell">
                Cuenta
              </div>
            </div>
            <div class="frwds rline vcenter">
              <div class="tabcell">
                Nombre de Empresa
              </div>
            </div>
            <div class="frwds rline vcenter">
              <div class="tabcell">
                Perfil / Rol
              </div>
            </div>
            <div class="frwds vcenter">
              <div class="tabcell">
                Estatus
              </div>
            </div>
          </div>
          <div class="containerOverFlow">
            <div class="basicrow" *ngFor="let account of this.filteredData; let i = index">
              <div>
                <div>
                  <div class="tab-cbar">
                    <div class="frwds rline vcenter">
                      <div class="tabcell">
                        <a class="">
                          {{account.account}}
                        </a>
                      </div>
                    </div>
                    <div class="frwds rline vcenter">
                      <div class="tabcell">
                        {{(account.accountName).replace('undefined','')| slice:0:15}}
                      </div>
                    </div>
                    <div class="frwds rline vcenter">
                      <div class="tabcell">
                        Administrador
                      </div>
                    </div>
                    <div class="frwds vcenter">
                      <div class="tabcell">
                        <div>
                          Activo
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="no-subscriber" *ngIf="this.filteredData.length==0">
              Cuentas no asociadas al parametro de búsqueda.
            </div>
          </div>
        </div>
        <div class="basicrow m-top visible-movil">
          <div class="basicrow mbott-i" id="last-div">
            <div id="myCarousel5" class="carousel slide" data-interval="false" data-ride="carousel">
              <!-- Indicators -->
              <ol class="carousel-indicators bot-select">
                <li data-target="#myCarousel5" data-slide-to="0" class="active"></li>
                <li data-target="#myCarousel5" data-slide-to="1"></li>
              </ol>
              <!-- Wrapper for slides -->
              <div class="carousel-inner">
                <carousel [interval]="false">
                  <slide>
                    <div class="item active">
                      <div class="boxtbl">
                        <div class="tab-tbar">
                          <div class="frwds rline vcenter">
                            <div class="tabcell">
                              Cuenta
                            </div>
                          </div>
                          <div class="frwds vcenter">
                            <div class="tabcell">
                              Nombre de Empresa
                            </div>
                          </div>
                        </div>
                        <div class="basicrow">
                          <div class="tab-cbar" ng-repeat="bill in vm.bills"
                            *ngFor="let account of this.filteredData; let i = index">
                            <div class="frwds rline vcenter">
                              <div class="tabcell">
                                {{account.account}}
                              </div>
                            </div>
                            <div class="frwds vcenter">
                              <div class="tabcell">
                                {{(((account.accountName).replace('undefined','')).replace('null','')).replace('NULL','')| slice:0:15}}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </slide>
                  <slide>
                    <div class="item">
                      <div class="boxtbl">
                        <div class="tab-tbar">
                          <div class="frwds rline vcenter">
                            <div class="tabcell">
                              Cantidad
                            </div>
                          </div>
                          <div class="frwds vcenter">
                            <div class="tabcell">
                              Ver Como
                            </div>
                          </div>
                        </div>
                        <div class="basicrow">
                          <div class="tab-cbar" ng-repeat="bill in vm.bills"
                            *ngFor="let account of this.filteredData; let i = index">
                            <div class="frwds rline vcenter">
                              <div class="tabcell">
                                Administrador
                              </div>
                            </div>
                            <div class="frwds vcenter">
                              <div class="tabcell">
                                <div>
                                  Activo
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </slide>
                </carousel>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>